import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/a767d65d-0e19-49c9-9380-a6816d196f72.png"
                alt="PoolChem Logo"
                className="w-10 h-10 object-contain"
              />
              <span className="text-2xl font-bold text-teal-400">PoolChem Monitor</span>
            </div>
            <p className="text-slate-300 mb-4 max-w-md">
              Sistema profesional de monitoreo químico para piscinas. Registra, valida y
              analiza parámetros químicos con reportes dinámicos y exportación avanzada.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:soporte@poolchem.com" className="text-slate-300 hover:text-teal-400 transition-colors">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="tel:+1234567890" className="text-slate-300 hover:text-teal-400 transition-colors">
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Funciones</h3>
            <ul className="space-y-2 text-slate-300">
              <li><Link to="/dashboard" className="hover:text-teal-400 transition-colors">Dashboard</Link></li>
              <li><Link to="/registro" className="hover:text-teal-400 transition-colors">Registro de Datos</Link></li>
              <li><Link to="/scuba3s" className="hover:text-teal-400 transition-colors">Scuba3s</Link></li>
              <li><Link to="/historial-alertas" className="hover:text-teal-400 transition-colors">Historial Alertas</Link></li>
              <li><Link to="/analisis" className="hover:text-teal-400 transition-colors">Análisis</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Parámetros Scuba3s</h3>
            <ul className="space-y-2 text-slate-300">
              <li>pH T (6.5-8.4)</li>
              <li>Cloro T (0.1-6.0 mg/L)</li>
              <li>Alcalinidad (5-300 mg/L)</li>
              <li>Dureza (50-500 mg/L)</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row md:items-center md:justify-between">
          <p className="text-slate-400 text-sm">
            © 2024 PoolChem Monitor. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <span className="text-slate-400 text-sm">Desarrollado con</span>
            <a
              href="/"
              className="text-teal-400 hover:text-teal-300 transition-colors text-sm font-medium"
            >
              PCJASH SOLUTIONS SAS
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}